@if (message()) {
  <div class="severity-info-text"
       [attr.data-testid]="testId()">
    <img src="assets/icons/info.svg"
         alt="Information"
         class="severity-info-icon">
    <span>{{ message() }}</span>
  </div>
}
